<template>
  <div style="margin-top: 20px">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" style="width: 750px; margin: 0px auto">
          <div slot="header" style="margin-bottom: 10px"></div>
          <div>
            <el-tabs style="padding-top: 10px" v-model="tabs" @tab-click="tabClick">
              <el-tab-pane label="报价器" name="menu">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>报价器设置</span>
                    <el-button style="float: right; padding: 3px 0" type="text" @click="setDefaultMenu">初始化</el-button>
                  </div>
                  <el-alert title="提示:排序的值需大于100。" type="warning"></el-alert>
                  <el-table :data="menus" style="width: 100%" size="mini">
                    <el-table-column prop="name" label="报价器" header-align="center" align="center"></el-table-column>
                    <el-table-column label="排序" header-align="center" align="center">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.level" @blur="onMenuChange"></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" header-align="center" align="center">
                      <template slot-scope="scope">
                        <el-switch v-model="scope.row.isCheck" active-text="开启" inactive-text="关闭"
                          @change="onMenuChange(scope.row)"></el-switch>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-card>
              </el-tab-pane>
              <!-- <el-tab-pane label="小信鸽" name="default">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>小信鸽设置</span>
                  </div>
                  <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="保留最近">
                      <el-input-number
                        v-model="num"
                        @change="handleChange"
                        :min="0"
                        label="请输入天数"
                      ></el-input-number>
                      天消息
                    </el-form-item>
                    <el-form-item label="提示音">
                      <el-switch
                        v-model="warningTone"
                        active-text="开启"
                        inactive-text="关闭"
                        @change="setWarningTone"
                      >
                      </el-switch>
                    </el-form-item>
                    <el-form-item label="平台消息提醒">
                      <el-switch
                        v-model="platformMsgWarn"
                        active-text="开启"
                        inactive-text="关闭"
                        @change="setPlatformMsgWarn"
                      >
                      </el-switch>
                    </el-form-item>
                    <el-form-item label="客服消息提醒">
                      <el-switch
                        v-model="serviceMsgWarn"
                        active-text="开启"
                        inactive-text="关闭"
                        @change="setServiceMsgWarn"
                      >
                      </el-switch>
                    </el-form-item>
                    <el-form-item label="">
                      <el-button type="text" @click="onRemoveDate"
                        >清空本地消息</el-button
                      >
                    </el-form-item>
                  </el-form>
                </el-card>
              </el-tab-pane> -->
              <el-tab-pane label="快捷键设置" name="shortcutKey">
                <el-card class="box-card">
                  <div slot="header" class="clearfix">
                    <span>快捷键设置</span>
                    <el-button style="float: right; padding: 3px 0" type="text" @click="resetKeys">恢复默认</el-button>
                  </div>
                  <el-alert title="提示：点击设置按钮后，按下您想要的快捷键组合。" type="warning" style="margin-bottom: 10px"></el-alert>
                  <el-alert title="注意：不同操作不要设置成相同的快捷键，否则会导致操作冲突，快捷键无法生效。" type="error"
                    style="margin-bottom: 10px"></el-alert>
                  <el-table :data="keys" style="width: 100%" size="mini">
                    <el-table-column prop="name" label="按钮名称" header-align="center" align="center"></el-table-column>
                    <el-table-column label="快捷键" header-align="center" align="center">
                      <template slot-scope="scope">
                        <span style="margin-right: 10px">{{ scope.row.keyCode | keyName }}</span>
                        <el-link type="primary" @click="showSetKey(scope.row, scope.$index)">设置</el-link>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-card>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog title="快捷键设置" :visible.sync="dialogVisible" width="30%" @close="onDialogClose">
      <div style="text-align: center; padding: 20px">
        <p style="margin-bottom: 20px">
          正在设置:
          <strong>{{ currentKey.name }}</strong>
        </p>
        <p style="margin-bottom: 20px">
          当前快捷键:
          <strong>{{ currentKey.keyCode | keyName }}</strong>
        </p>
        <p style="color: #909399; font-size: 14px">请按下您想要设置的快捷键组合</p>
        <p style="color: #909399; font-size: 12px; margin-top: 10px">支持组合键,如: Ctrl+A, Alt+S 等</p>
        <div v-if="pressedKeys.length > 0"
          style="margin-top: 20px; padding: 10px; background: #f5f7fa; border-radius: 4px">
          <p style="color: #606266; font-size: 14px">已按下: {{ pressedKeys.join(' + ') }}</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveKey">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { initData } from '../api/MsgApi';
import localforage from 'localforage';

export default {
  name: 'Set',
  data() {
    return {
      form: {},
      num: 10,
      removeDate: '',
      user: {},
      warningTone: true,
      platformMsgWarn: true,
      serviceMsgWarn: true,
      tabs: 'menu',
      menus: [],
      selectMenus: [],
      keys: [],
      dialogVisible: false,
      currentKey: {
        name: '',
        keyCode: '',
      },
      currentKeyIndex: -1,
      pressedKeys: [],
      capturedKeyCodes: [],
    };
  },
  created() {
    this.user = this.$store.getters['user'];
    this.getNum();
    this.getWarningTone();
    this.platformMsgWarn = this.$store.getters.platformMsgWarn;
    this.serviceMsgWarn = this.$store.getters.serviceMsgWarn;
    this.getMenu();
    this.getHortcutsKey();
  },
  filters: {
    keyName(val) {
      let s = val.split('^');
      let name = '';
      console.log(s);
      s.forEach((item, index) => {
        console.log(item);
        switch (item) {
          case '-1':
            name += '未设置' + '+';
            break;
          case '13':
            name += '回车' + '+';
            break;
          case '32':
            name += '空格' + '+';
            break;
          case '27':
            name += 'Esc' + '+';
            break;
          case '9':
            name += 'Tab' + '+';
            break;
          case '8':
            name += 'Backspace' + '+';
            break;
          case '46':
            name += 'Delete' + '+';
            break;
          case '36':
            name += 'Home' + '+';
            break;
          case '35':
            name += 'End' + '+';
            break;
          case '33':
            name += 'PageUp' + '+';
            break;
          case '34':
            name += 'PageDown' + '+';
            break;
          case '37':
            name += '←' + '+';
            break;
          case '38':
            name += '↑' + '+';
            break;
          case '39':
            name += '→' + '+';
            break;
          case '40':
            name += '↓' + '+';
            break;
          case 'Ctrl':
            name += 'Ctrl' + '+';
            break;
          case 'Alt':
            name += 'Alt' + '+';
            break;
          case 'Shift':
            name += 'Shift' + '+';
            break;
          default:
            name += String.fromCharCode(item) + '+';
            break;
        }
      });
      name = name.substring(0, name.length - 1);
      return name;
    },
  },
  methods: {
    //消息保留天数
    getNum() {
      let localNum = localStorage.getItem(this.user.accountNo + '_setNum');
      if (localNum == undefined) {
        localStorage.setItem(this.user.accountNo + '_setNum', 10);
      } else {
        this.num = localNum;
      }
    },
    //获取提示音
    getWarningTone() {
      let _warningTone = localStorage.getItem(this.user.accountNo + '_warningTone');
      if (_warningTone == undefined) {
        _warningTone = true;
        localStorage.setItem(this.user.accountNo + '_warningTone', _warningTone);
      }
      this.warningTone = _warningTone == 'true' ? true : false;
    },
    //提示音保存到本地数据库
    setWarningTone(value) {
      localStorage.setItem(this.user.accountNo + '_warningTone', value);
      this.$store.commit('SET_IS_PLAYING', value);
    },
    //系统提醒保留到本地数据库
    setServiceMsgWarn(value) {
      localStorage.setItem(this.user.accountNo + '_serviceMsgWarn', value);
      this.$store.commit('SET_SERVICE_MSG_WARN', value);
    },
    //客服提醒保留到本地数据库
    setPlatformMsgWarn(value) {
      localStorage.setItem(this.user.accountNo + '_platformMsgWarn', value);
      this.$store.commit('SET_PLATFORM_MSG_WARN', value);
    },
    //本地消息天数保留到本地数据库
    handleChange(value) {
      localStorage.setItem(this.user.accountNo + '_setNum', value);
    },
    //清空本地消息
    onRemoveDate() {
      let that = this;
      this.$confirm('此操作将永久删除本地聊天记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          that.removeDB();
          that.$message({
            type: 'success',
            showClose: true,
            message: '删除成功!',
          });
        })
        .catch(() => {
          that.$message({
            type: 'info',
            showClose: true,
            message: '已取消删除',
          });
        });
    },
    removeDB() {
      let that = this;
      let date = new Date();
      let num = this.num;
      this.removeDate = date.setTime(date.valueOf() - num * 24 * 60 * 60 * 1000);
      let db = this.$store.getters.webDB;
      db.iterate(function (value1, key, iterationNumber) {
        // 此回调函数将对所有 key/value 键值对运行
      })
        .then(function () {
          console.log('Iteration has completed');
        })
        .catch(function (err) {
          // 当出错时，此处代码运行
          console.log(err);
        });
    },

    getMenu() {
      let menu = localStorage.getItem('menu_' + this.user.accountNo);
      if (menu != null) {
        this.menus = JSON.parse(menu);
        this.menus = this._.orderBy(this.menus, ['level'], ['asc']);
      } else {
        this.menus = that.$store.getters['defaultMenu'];
        this.menus = this._.orderBy(this.menus, ['level'], ['asc']);
      }
    },
    tabClick(tab, event) {
      if (tab.name == 'menu') {
        this.getMenu();
      }
    },
    onMenuChange(row) {
      let that = this;
      //读取默认的menu列表
      let menuList = this.menus;
      //更新到数据库中
      localStorage.setItem('menu_' + this.user.accountNo, JSON.stringify(menuList));
      let defaultPriceUrls = menuList.filter(item => {
        if (item.isCheck) {
          return item;
        }
      });
      //修改默认的报价器url
      localStorage.setItem('DEFAULT_PRICE_URL', defaultPriceUrls[0].path);
      this.getMenu();
    },
    //初始化按钮
    setDefaultMenu() {
      let menu = this.$store.getters['defaultMenu'];
      let version = this.$store.state.menuVersion;
      localStorage.setItem('menu_' + this.user.accountNo, JSON.stringify(menu));
      localStorage.setItem('menuVersion_' + this.accountNo, version);
      this.$message({
        type: 'success',
        showClose: true,
        message: '初始化成功!',
      });
      this.getMenu();
    },
    //获取快捷键
    getHortcutsKey() {
      let that = this;
      let keys = localStorage.getItem('key_' + this.user.accountNo);
      if (keys != null) {
        this.keys = JSON.parse(keys);
      } else {
        this.keys = JSON.parse(JSON.stringify(that.$store.getters['keys']));
      }
    },
    //显示设置快捷键对话框
    showSetKey(row, index) {
      this.currentKey = { ...row };
      this.currentKeyIndex = index;
      this.pressedKeys = [];
      this.capturedKeyCodes = [];
      this.dialogVisible = true;

      // 延迟添加事件监听,避免立即触发
      this.$nextTick(() => {
        document.addEventListener('keydown', this.captureKey);
      });
    },
    //捕获按键
    captureKey(event) {
      event.preventDefault();
      event.stopPropagation();

      const keyCode = event.keyCode;
      const key = event.key;

      // 构建按键显示名称
      let keyName = '';
      let keyCodes = [];

      // 检测修饰键
      if (event.ctrlKey || event.metaKey) {
        keyName += 'Ctrl+';
        keyCodes.push('Ctrl');
      }
      if (event.altKey) {
        keyName += 'Alt+';
        keyCodes.push('Alt');
      }
      if (event.shiftKey) {
        keyName += 'Shift+';
        keyCodes.push('Shift');
      }

      // 添加主键
      if (keyCode === 13) {
        keyName += '回车';
        keyCodes.push(keyCode);
      } else if (keyCode === 32) {
        keyName += '空格';
        keyCodes.push(keyCode);
      } else if (keyCode === 27) {
        keyName += 'Esc';
        keyCodes.push(keyCode);
      } else if (keyCode === 9) {
        keyName += 'Tab';
        keyCodes.push(keyCode);
      } else if (keyCode === 8) {
        keyName += 'Backspace';
        keyCodes.push(keyCode);
      } else if (keyCode === 46) {
        keyName += 'Delete';
        keyCodes.push(keyCode);
      } else if (keyCode === 36) {
        keyName += 'Home';
        keyCodes.push(keyCode);
      } else if (keyCode === 35) {
        keyName += 'End';
        keyCodes.push(keyCode);
      } else if (keyCode === 33) {
        keyName += 'PageUp';
        keyCodes.push(keyCode);
      } else if (keyCode === 34) {
        keyName += 'PageDown';
        keyCodes.push(keyCode);
      } else if (keyCode === 37) {
        keyName += '←';
        keyCodes.push(keyCode);
      } else if (keyCode === 38) {
        keyName += '↑';
        keyCodes.push(keyCode);
      } else if (keyCode === 39) {
        keyName += '→';
        keyCodes.push(keyCode);
      } else if (keyCode === 40) {
        keyName += '↓';
        keyCodes.push(keyCode);
      } else if (keyCode >= 65 && keyCode <= 90) {
        // A-Z
        keyName += String.fromCharCode(keyCode);
        keyCodes.push(keyCode);
      } else if (keyCode >= 48 && keyCode <= 57) {
        // 0-9
        keyName += String.fromCharCode(keyCode);
        keyCodes.push(keyCode);
      } else if (keyCode >= 112 && keyCode <= 123) {
        // F1-F12
        keyName += 'F' + (keyCode - 111);
        keyCodes.push(keyCode);
      } else if (!event.ctrlKey && !event.altKey && !event.shiftKey && !event.metaKey) {
        // 其他单独按键
        keyName += key.toUpperCase();
        keyCodes.push(keyCode);
      }

      // 移除末尾的+号
      if (keyName.endsWith('+')) {
        keyName = keyName.slice(0, -1);
      }

      // 更新显示
      if (keyCodes.length > 0) {
        this.pressedKeys = keyName.split('+');
        this.capturedKeyCodes = keyCodes;

        // 构建keyCode字符串 (用^分隔)
        let keyCodeStr = '';
        keyCodes.forEach((code, index) => {
          if (typeof code === 'number') {
            keyCodeStr += code;
          }
          if (index < keyCodes.length - 1) {
            keyCodeStr += '^';
          }
        });

        this.currentKey.keyCode = keyCodeStr;
      }
    },
    //保存快捷键
    saveKey() {
      if (this.capturedKeyCodes.length === 0) {
        this.$message.warning('请先按下快捷键');
        return;
      }

      // 更新keys数组
      this.$set(this.keys, this.currentKeyIndex, { ...this.currentKey });

      // 保存到本地存储
      localStorage.setItem('key_' + this.user.accountNo, JSON.stringify(this.keys));

      this.$message.success('快捷键设置成功');
      this.dialogVisible = false;
    },
    //对话框关闭时移除事件监听
    onDialogClose() {
      document.removeEventListener('keydown', this.captureKey);
      this.pressedKeys = [];
      this.capturedKeyCodes = [];
    },
    //恢复默认快捷键
    resetKeys() {
      this.$confirm('此操作将恢复默认快捷键设置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.keys = JSON.parse(JSON.stringify(this.$store.getters['keys']));
          localStorage.setItem('key_' + this.user.accountNo, JSON.stringify(this.keys));
          this.$message.success('已恢复默认快捷键设置');
        })
        .catch(() => {
          this.$message.info('已取消操作');
        });
    },
  },
};
</script>

<style scoped>
::v-deep .el-card__body {
  padding-top: 10px;
}
</style>
